export const isBlogPage = (pathname: string) => {
  return pathname.startsWith('/blogV2');
};
